import { PaginatedResponse } from '@synergy/api';
import { createReducer } from '@reduxjs/toolkit';

import { NewsPostDto } from '../models/dto/news-post-dto';
import { newsDetailReceived, newsReceived, newsSliderItemsReceived } from './news-actions';

export interface NewsState {
    newsSliderItems: PaginatedResponse<NewsPostDto>;
    news: PaginatedResponse<NewsPostDto>;
    newsDetail?: NewsPostDto;
}

const initialState: NewsState = {
    newsSliderItems: { items: [], limit: 0, page: 1, total: 0, pages: 0 },
    news: { items: [], limit: 0, page: 1, total: 0, pages: 0 },
};

export const newsReducer = createReducer(initialState, builder => {
    builder.addCase(newsReceived, (state, action) => ({ ...state, news: action.payload }));
    builder.addCase(newsSliderItemsReceived, (state, action) => ({
        ...state,
        newsSliderItems: {
            ...action.payload,
            items:
                action.payload.page === 1
                    ? action.payload.items
                    : [...state.newsSliderItems.items, ...action.payload.items],
        },
    }));
    builder.addCase(newsDetailReceived, (state, action) => ({ ...state, newsDetail: action.payload }));
});
